<template>
  <div class="tabs-wrapper">
    <ul class="tabs-items">
      <li
        v-for="(name, index) in slots"
        :key="index"
        :class="[selected == index ? 'tab-active' : '']"
        @click="selected = index"
      >{{ name }}</li>
      <li v-if="expandable" class="expand-button" @click="expanded = !expanded" :class="expanded ? '' : 'closed'">
        <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg" class=""><path d="M9.70711 0.707101L16.75 7.75C17.4404 8.44035 17.4404 9.55964 16.75 10.25C16.0596 10.9404 14.9404 10.9404 14.25 10.25L9 5L3.75 10.25C3.05964 10.9404 1.94036 10.9404 1.25 10.25C0.559645 9.55964 0.559644 8.44036 1.25 7.75L8.29289 0.707102C8.68342 0.316577 9.31658 0.316576 9.70711 0.707101Z" fill="#5F5F5F"></path></svg>
      </li>
    </ul>
    <transition name="fade" tag="div" v-if="renderInactive || expanded" v-show="expanded">
      <transition-group name="fade" tag="div" class="tabs-content">
        <template v-for="(name, index) in slots">
            <div
              v-if="renderInactive || selected == index"
              v-show="selected == index"
              :key="index"
            >
              <slot :name="name"></slot>
            </div>
          </template>
      </transition-group>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'TabsSlots',
  props: {
    value: {
      type: Number,
      default: () => 0,
    },
    renderInactive: {
      type: Boolean,
      default: () => false,
    },
    expandable: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    selected(val) {
      this.$emit('input', val);
    },
  },
  data: () => ({
    selected: 0,
    expanded: true,
  }),
  computed: {
    slots () {
      return Object.keys(this.$slots);
    },
  },
});
</script>

<style lang="scss" scoped>
  .expand-button {
    margin-left: auto;
    transition: all .3s linear;

    &.closed {
      transform: rotate(180deg);
    }
  }
  .tabs-items {
    display: flex;
    flex-flow: row wrap;
    margin-bottom: 2px;
    background-color: #F3F3F3;
    margin-top: 10px;

    > li {
      padding: 15px 25px;
      cursor: pointer;
      transition: all .2s linear;
      font-weight: bold;
      color: #666;

      &.tab-active {
        background: #fff;
        color: #000;
      }
    }
  }
</style>
